<template>
  <g>
    <path
      d="M5 7.00018H19C19.55 7.00018 20 7.45018 20 8.00018C20 8.55018 19.55 9.00018 19 9.00018H5C4.45 9.00018 4 8.55018 4 8.00018C4 7.45018 4.45 7.00018 5 7.00018Z"
    />
    <path
      d="M5 13.0002H19C19.55 13.0002 20 12.5502 20 12.0002C20 11.4502 19.55 11.0002 19 11.0002H5C4.45 11.0002 4 11.4502 4 12.0002C4 12.5502 4.45 13.0002 5 13.0002Z"
    />
    <path
      d="M5 17.0002H10C10.55 17.0002 11 16.5502 11 16.0002C11 15.4502 10.55 15.0002 10 15.0002H5C4.45 15.0002 4 15.4502 4 16.0002C4 16.5502 4.45 17.0002 5 17.0002Z"
    />
    <path
      d="M5 21.0002H10C10.55 21.0002 11 20.5502 11 20.0002C11 19.4502 10.55 19.0002 10 19.0002H5C4.45 19.0002 4 19.4502 4 20.0002C4 20.5502 4.45 21.0002 5 21.0002Z"
    />
    <path
      d="M15.4101 18.1702L14.7001 17.4602C14.3101 17.0702 13.6801 17.0702 13.2901 17.4602C12.9001 17.8502 12.9001 18.4802 13.2901 18.8702L14.7101 20.2902C15.1001 20.6802 15.7301 20.6802 16.1201 20.2902L19.2901 17.1202C19.6801 16.7302 19.6801 16.1002 19.2901 15.7102C18.9001 15.3202 18.2701 15.3202 17.8801 15.7102L15.4101 18.1702Z"
    />
    <path
      d="M4 4.00018C4 4.55018 4.45 5.00018 5 5.00018H19C19.55 5.00018 20 4.55018 20 4.00018C20 3.45018 19.55 3.00018 19 3.00018H5C4.45 3.00018 4 3.45018 4 4.00018Z"
    />
  </g>
</template>
